__webpack_require__.p = "https://dev-028040229547.assessments.security.amazon.dev/";